import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "components/navbar/Navbar";
import MobileTabBar from "components/navbar/MobileTabBar";
import Header from "components/Header";
import MobileHeader from "components/MobileHeader";
import { CurrentUserContext } from "../App";

const pageNames = {
  memories: "Memories",
  search: "Search",
  connect: "Connect",
  chat: "Chat",
  profile: "Profile",
  notifications: "Notifications",
  feedback: "Feedback",
};

export default function RootLayout() {
  const { currentUser } = useContext(CurrentUserContext);
  const [pageH1, setPageH1] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPage = window.location.pathname.substring(1);
    setPageH1(currentPage);
  }, [location.pathname]);

  useEffect(() => {
    const storedUser = localStorage.getItem("currentUser");
    const storedUserObject = storedUser ? JSON.parse(storedUser) : null;
    if (!storedUserObject?.token || !storedUserObject?.email) {
      return navigate("/login");
    }

    if (!storedUserObject?.emailIsVerified) {
      return navigate("/login/emailVerification");
    } else if (!storedUserObject?.username) {
      return navigate("/login/newusername");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const currentPageKey = location.pathname.substring(1).split("/")[0];
  const pageTitle = pageNames[currentPageKey] || currentPageKey;

  return currentUser ? (
    <div className="root-layout">
      {/* Desktop header — hidden on mobile via CSS */}
      <Header pageH1={pageH1} className="desktop-header" />

      {/* Mobile header — hidden on desktop via CSS, occupies grid header area on mobile */}
      <MobileHeader title={pageTitle} />

      {/* Desktop sidebar navbar — hidden on mobile via CSS (aside is display:none) */}
      <aside className="d-flex justify-content-end">
        <Navbar />
      </aside>

      {/* MAIN CONTENT */}
      <main id="main-content-area">
        <Outlet />
      </main>

      {/* Mobile bottom tab bar — hidden on desktop via CSS */}
      <MobileTabBar />
    </div>
  ) : (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="spinner-border text-light" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
